import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import moment from "moment"
import React, { useEffect, useState } from "react"
import {
  FaChevronLeft,
  FaChevronRight,
  FaEdit,
  FaEye,
  FaPlus,
} from "react-icons/fa"
import { MdDelete } from "react-icons/md"
import { Button, Card, CardBody, Input, Table } from "reactstrap"
import Swal from "sweetalert2"
import RolesModal from "./RolesModal"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import { usePermissionData } from "AppContext"

const RolesIndex = () => {
  document.title = "Roles & Permissions | Milano Jewelry"

  const { checkAccess } = usePermissionData()

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])

  const [pageSize, setPageSize] = useState(10)
  const [searchString, setSearchString] = useState("")
  const [currentPage, setCurrentPage] = useState(1)

  /* ================= SAMPLE DATA ================= */
  useEffect(() => {
    getRolesData()
  }, [])

  async function getRolesData() {
    const APIdata = await fetchData(setLoading, "roles")
    if (APIdata?.success) {
      setData(APIdata?.data)
    }
  }

  /* ================= SEARCH ================= */

  const filteredData = data.filter(item =>
    [item.roleName, item.createdAt]
      .join(" ")
      .toLowerCase()
      .includes(searchString.toLowerCase())
  )

  /* ================= PAGINATION ================= */

  const totalPages = Math.ceil(filteredData.length / pageSize)

  const paginatedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  )

  // Modal
  const [formData, setFormData] = useState({})
  const [mode, setMode] = useState("add")
  const [roleModal, setRoleModal] = useState(false)

  const handleSubmit = async updatedFormData => {
    console.log(updatedFormData)
    if (updatedFormData?.id) {
      const APIdata = await FetchPutData(
        setLoading,
        "roles",
        updatedFormData?.id,
        updatedFormData
      )
      if (APIdata?.data?.success) {
        setRoleModal(false)
        Swal.fire({
          title: "Role Updated Successfully",
          text: APIdata?.data?.message,
          icon: "success",
        })
        setTimeout(() => {
          getRolesData()
        }, 1500)
      } else {
        Swal.fire({
          title: "Error Adding Role",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    } else {
      const APIdata = await FetchPostData(setLoading, "roles", updatedFormData)
      if (APIdata?.data?.success) {
        setRoleModal(false)
        Swal.fire({
          title: "Role Added Successfully",
          text: APIdata?.data?.message,
          icon: "success",
        })
        setTimeout(() => {
          getRolesData()
        }, 1500)
      } else {
        Swal.fire({
          title: "Error Adding Role",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    }
  }

  const handleDelete = async item => {
    const confirm = await Swal.fire({
      title: "Are you Sure?",
      text: `you want to Delete this ${item?.roleName} Staff`,
      icon: "warning",
      showCancelButton: true,
    })

    if (!confirm.isConfirmed) {
      return
    }

    const APIdata = await FetchDeleteData(setLoading, "roles", item?.id)
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Role Deleted Successfully",
        text: APIdata?.data?.message,
        icon: "success",
      })
      setTimeout(() => {
        getRolesData()
      }, 1500)
    } else {
      Swal.fire({
        title: "Error deleting Role",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb title="Settings" breadcrumbItem="Roles & Permissions" />

      <Card>
        <CardBody>
          {/* ===== FILTERS ===== */}
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex gap-3">
              <select
                className="form-select rounded-3"
                style={{ width: "100px" }}
                value={pageSize}
                onChange={e => {
                  setPageSize(Number(e.target.value))
                  setCurrentPage(1)
                }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>

              <Input
                placeholder="Search..."
                className="rounded-3"
                value={searchString}
                onChange={e => {
                  setSearchString(e.target.value)
                  setCurrentPage(1)
                }}
              />
            </div>
            {checkAccess(5, "add") && (
              <Button
                className="btn-blue rounded-3"
                onClick={() => {
                  setFormData({}), setRoleModal(true), setMode("add")
                }}
              >
                <FaPlus /> Add Role
              </Button>
            )}
          </div>

          {/* ===== TABLE ===== */}
          <Table striped responsive>
            <thead className="table-blue">
              <tr>
                <th>#</th>
                <th>Role Name</th>
                <th>Created At</th>
                <th>Updated At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length === 0 && (
                <tr>
                  <td colSpan="5" className="text-center">
                    No Records Found
                  </td>
                </tr>
              )}
              {paginatedData.map((item, index) => (
                <tr key={item.id}>
                  <td>{(currentPage - 1) * pageSize + index + 1}</td>
                  <td>{item?.roleName}</td>
                  <td>
                    {item?.createdAt
                      ? moment(item.createdAt).format("MM-DD-YYYY")
                      : "--"}
                  </td>
                  <td>
                    {item?.updatedAt
                      ? moment(item.updatedAt).format("MM-DD-YYYY")
                      : "--"}
                  </td>
                  <td className="d-flex gap-3">
                    <Button
                      className="btn-secondary"
                      onClick={() => {
                        setFormData(item), setRoleModal(true), setMode("view")
                      }}
                    >
                      <FaEye />
                    </Button>
                    {checkAccess(5, "edit") && (
                      <Button
                        className="btn-success"
                        onClick={() => {
                          setFormData(item),
                            setRoleModal(true),
                            setMode("edit")
                        }}
                      >
                        <FaEdit />
                      </Button>
                    )}
                    {checkAccess(5, "delete") && (
                      <Button
                        className="btn-danger"
                        onClick={() => handleDelete(item)}
                      >
                        <MdDelete />
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {/* ===== PAGINATION ===== */}
          <div className="d-flex justify-content-between">
            <span className="align-self-center">
              Page {currentPage} of {totalPages || 1}
            </span>
            {/* ===== PAGINATION ===== */}
            <div className="d-flex justify-content-center align-items-center gap-2 ">
              {/* Previous */}
              <Button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(prev => prev - 1)}
                className="btn-blue"
              >
                <FaChevronLeft />
              </Button>

              {/* Page Numbers (Show 5 at a time) */}
              {(() => {
                const pageNumbers = []
                const maxVisiblePages = 5

                let startPage = Math.max(
                  1,
                  currentPage - Math.floor(maxVisiblePages / 2)
                )

                let endPage = startPage + maxVisiblePages - 1

                if (endPage > totalPages) {
                  endPage = totalPages
                  startPage = Math.max(1, endPage - maxVisiblePages + 1)
                }

                for (let i = startPage; i <= endPage; i++) {
                  pageNumbers.push(
                    <Button
                      key={i}
                      color={currentPage === i ? "primary" : "light"}
                      onClick={() => setCurrentPage(i)}
                    >
                      {i}
                    </Button>
                  )
                }

                return pageNumbers
              })()}

              {/* Next */}
              <Button
                disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => setCurrentPage(prev => prev + 1)}
                className="btn-blue"
              >
                <FaChevronRight />
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>

      <RolesModal
        open={roleModal}
        close={() => setRoleModal(false)}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleSubmit}
        mode={mode}
      />
    </div>
  )
}

export default RolesIndex
